import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
const initialState = {
  workouts: [],
  workoutsLoading: false,
  specificWorkout: null,
  addPlanLoading: false,
  addWorkoutLoading:false,
  editBtnLoading: false,
  deleteBtnLoading: false,
  editWorkoutLoading: false,
  deleteWorkoutLoading: false,
  // maxWorkoutsLength:false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_WORKOUT_PLANS:
      return updateObject(state, action.payload);
    case actionTypes.WORKOUT_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
